var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 86 H22 A19 19 0 0 1 22 48 A27 27 0 0 1 64 22",
    fill: "none",
    stroke: "#2c2416",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50 A18 18 0 0 1 96 86 H90",
    fill: "none",
    stroke: "#2c2416",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(84 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 17,
    fill: "none",
    stroke: "#2c2416",
    strokeWidth: 7,
    strokeDasharray: "6.7 6.65"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.5,
    fill: "none",
    stroke: "#2c2416",
    strokeWidth: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 900,
    fill: "#2c2416",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 66,
    fontSize: 21
  }, "REST"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 97,
    fontSize: 31
  }, "API"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestApi);
export default __webpack_public_path__ + "static/media/rest-api.b47ed4df03d02395c6108937c6f4495f.svg";
export { ForwardRef as ReactComponent };